import React from 'react';

// KilalaRide brand mark: a shield with a road running up the middle.
export const LogoMark = ({ size = 40, title = 'KilalaRide' }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={title} data-testid="logo-mark">
    <defs>
      <linearGradient id="ss-shield" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#0FA3A8" />
        <stop offset="1" stopColor="#0D3B4E" />
      </linearGradient>
    </defs>
    {/* Shield */}
    <path
      d="M32 3 L55 12 V31 C55 45.5 45.4 55.6 32 61 C18.6 55.6 9 45.5 9 31 V12 Z"
      fill="url(#ss-shield)"
      stroke="#25C6E8"
      strokeWidth="1.5"
    />
    {/* Road (perspective) */}
    <path d="M24.5 51 L39.5 51 L35.5 21 L28.5 21 Z" fill="#F5FBFC" />
    {/* Center dashes (brand yellow) */}
    <g fill="#FFC43D">
      <rect x="31" y="45" width="2.2" height="5" rx="1" />
      <rect x="31.2" y="36" width="1.9" height="4.4" rx="1" />
      <rect x="31.4" y="28" width="1.6" height="3.6" rx="1" />
      <rect x="31.6" y="22" width="1.3" height="2.8" rx="1" />
    </g>
  </svg>
);

export const Logo = ({ size = 28, showText = true }) => (
  <div className="flex items-center gap-2 select-none">
    <LogoMark size={size + 12} />
    {showText && (
      <span className="font-extrabold tracking-tight text-lg" style={{ color: 'var(--text)' }}>
        Kilala<span style={{ color: 'var(--primary)' }}>Ride</span>
      </span>
    )}
  </div>
);
